import { configService } from "@/settings/api-url";

const actions = {
  async action_getUser({ commit }) {
    try {
      const { data } = await configService(`/normal_user`);
      commit("USER", data);
      return data;
    } catch (error) {
      return error.response;
    }
  },

  async action_getCountriesCodes({}) {
    try {
      let res = await configService(`/countries`);
      let { data } = res;
      return data;
    } catch (error) {
      return error.response;
    }
  },

  async action_getCitiesInformation({}, codeCity) {
    try {
      let res = await configService(`/countries/${codeCity}/`);
      let { data } = res;
      return data;
    } catch (error) {
      return error.response;
    }
  },

  async action_getRecents({ commit }) {
    try {
      let res = await configService(`/normal_user/recent_products`);
      let { data } = res;
      if (res && res.data && res.data.products_bought) {
        commit("RECENT_PRODUCTS", res.data.products_bought);
      }
      if (data.university) commit("UNIVERSITY", data.university);
      return data;
    } catch (error) {
      return error.response;
    }
  },
  async action_putUser({ dispatch, getters }, data) {
    try {
      const res = await configService(`/user/${getters.getUser.id}`, {
        method: "PUT",
        data,
      });
      dispatch("action_getUser");
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_putUserOnly({ getters, commit }, payload) {
    try {
      commit("CART_TEMPORAL", []);
      commit("CARTPRODUCTS", []);
      commit("CART", null);
      const res = await configService(`user/${getters.getUser.id}`, {
        method: "PUT",
        data: payload,
      });
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  action_getUniversityVariables({ commit }) {
    return configService("normal_user/university_variables")
      .then((response) => {
        const message = response.data.find((variable) => {
          return variable.name === "rappipay_message";
        });
        commit("UNIVERSITY_VARIABLES", response.data);
        commit("RAPPY_PAY_MESSAGE", message);
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  action_getQuetions({ commit }) {
    return configService(`/normal_user/questions`)
      .then((res) => {
        commit("QUESTIONS", res.data);
        return res;
      })
      .catch((error) => error.response);
  },
  action_postQuetions({}, data) {
    return configService(`/normal_user/answers`, {
      method: "POST",
      data,
    }).then((res) => {
      return res;
    });
  },
  async action_createCreditCard({ dispatch }, data) {
    try {
      const res = await configService("credit_cards", {
        method: "POST",
        data: data,
      });
      dispatch("action_getUser");
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async action_validateCreditCard({ dispatch }, data) {
    try {
      const res = await configService("normal_user/credit_cards/validate", {
        method: "POST",
        data: data,
      });
      dispatch("action_getUser");
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_tokenizeCreditCardMex({}, data) {
    try {
      (window as any).Conekta.setPublicKey("key_UJvdh29axK5jM6VJVFH8H3A");
      const creditCardInfo = data.credit_card;
      const parsedDate = creditCardInfo.expiration_date.split("/");

      const tokenParams = {
        card: {
          number: creditCardInfo.credit_card_number,
          name: creditCardInfo.name,
          exp_year: parsedDate[1],
          exp_month: parsedDate[0],
          cvc: creditCardInfo.ccv,
        },
      };
      return new Promise((resolve, reject) => {
        (window as any).Conekta.Token.create(
          tokenParams,
          async (token) => {
            const tokenCard = token.id;
            resolve(tokenCard);
          },
          (error) => {
            return reject(error);
          }
        );
      });
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_createCreditCardMex({ dispatch }, data) {
    try {
      await configService("credit_cards_mex", {
        method: "POST",
        data: { credit_card: { token: data.token, address: data.address } },
      });
      dispatch("action_getUser");
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_queryAddress({}, data) {
    try {
      const resp = await configService(`/query_address?query=${data}`);
      return resp.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_queryAddressByCoordinates({}, data) {
    try {
      const resp = await configService(`/query_address_by_coordinates?query=${data}`);
      return resp.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_createAddress({ dispatch, commit }, data) {
    const res = await configService("addresses", {
      method: "POST",
      data: data,
    });
    commit("CURRENT_ADDRESS", res.data);
    await dispatch("action_getUser");
    return res.data;
  },
  async action_deleteAddress({ commit, dispatch }, id) {
    await configService(`addresses/${id}`, {
      method: "PUT",
      data: { is_deleted: true },
    });
    commit("CURRENT_ADDRESS", null);
    await dispatch("action_getUser");
  },
  async action_getAcceptanceToken({ commit }) {
    try {
      const res = await configService("acceptance_token", {
        method: "GET",
      });
      commit("ACCEPTANCE_TOKEN", res.data);
      return res.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_getBankPse({ commit }) {
    try {
      const res = await configService("/pse_banks");
      commit("PSE_BANKS", res.data.data);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  action_deleteCreditCard({ dispatch }, id) {
    return configService(`normal_user/credit_cards/${id}`, {
      method: "DELETE",
    }).then((res) => {
      dispatch("action_getUser");
      return res;
    });
  },

  /* Create user */
  async action_createUser({}, dataReg) {
    try {
      const res = await configService("/user", {
        method: "POST",
        data: dataReg,
      });
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_isOnDemandValid({ commit }, payload) {
    try {
      const res = await configService(
        `normal_user/orders/valid_on_demand_distance?address_id=${payload}`
      );
      if (res && res.data) {
        commit("IS_ON_DEMAND_VALID", res.data);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_updateNormalUserInformation({ dispatch }, payload) {
    try {
      const { data } = await configService("normal_user", { method: "PUT", data: payload });
      await dispatch("action_getUser");
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

export default actions;
